<div class="container-fluid"  style="background: #F6F6F6;">
    <div class="container py-3" >
        <div class="row d-flex justify-content-around">
            
            <div class="col-12 col-md-3">
                <div class="card shadow-sm">
                    <div class="card-header d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon style="color: #00A384;">navigation</mat-icon> ORIGEN
                    </div>
                    <div class="card-body">
                        <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almacenOrigen">
                            <option value="-1" selected >--Todos--</option>
                            <option value="-10" selected >--Almacenes Ombligo--</option>
                            <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}</option>
                        </select>
                    </div>
                  </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="card shadow-sm">
                    <div class="card-header d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon style="color: #00A384;">pin_drop</mat-icon> DESTINO
                    </div>
                    <div class="card-body">
                        <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almacenDestino">
                            <option value="-1" selected >--Todos--</option>
                            <option value="-10" selected >--Almacenes Ombligo--</option>
                            <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}</option>
                        </select>
                    </div>
                  </div>
            </div>
            <div class="col-12 col-md-2">
                <div class="card shadow-sm">
                    <div class="card-header  d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon  style="color: #00A384;">cloud_download</mat-icon> * DESCARGAR
                    </div>
                    <div class="card-body " >
                        <div class="text-center" *ngIf="spiner" >
                            <img  src="assets/img/cargando.gif"alt="" class="h-50">
                        </div>
                        <div *ngIf="!spiner" class="col-12 text-center d-flex justify-content-center">
                            <button (click)="exportToExcel()" class="btn text-success p-0"><i class="fa-solid fa-file-excel h2 mb-0"></i></button>
                        </div>
                    </div>
               </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 table-responsive ">
                <div  class="my-5  shadow-sm tableRound">
                    <div class="col-12 d-flex justify-content-center" *ngIf="arrayTransitos.length==0">
                        <mat-spinner></mat-spinner>
                        <!-- <img  src="assets/img/cargando.gif" class="text-center" alt="" > -->
                    </div>
                    <div *ngIf="arrayTransitos && arrayTransitos.length>0 && ( arrayTransitos | filtrarAlmArticulos: strBusqueda).length > 0 " class="tableh ">
                    <table class="mb-0 table table-striped table-bordered tableRound">
                        <thead>
      
                            <tr class="thcenter fijetop ">
                                <th class="fw-bold fs14 nunito tleftRound">ORIGEN</th>
                                <th class="fw-bold fs14 nunito ">DESTINO</th> 
                                <th class="fw-bold fs14 nunito ">VOLUMEN</th>
                                <th class="fw-bold fs14 nunito ">PESO</th>
                                <th class="fw-bold fs14 nunito tendtRound"></th> 
                            </tr>
               
                        </thead>
                        <tbody *ngFor="let objeto of arrayTransitos | filtrarAlmArticulos:strBusqueda |filtrarAlmOrigenDestino:almacenOrigen:almacenDestino; ; let ind = index"><!--*ngFor="let objeto of objetosAgrupadosPorLinea[linea]"-->



                               <!--  <tr *ngFor="let objeto of arrayTransitos | filtrarAlmArticulos:strBusqueda  ">  -->
                                 <tr  data-bs-toggle="collapse" [attr.data-bs-target]="'#details-' + ind" aria-expanded="false" [attr.aria-controls]="'details-' + ind" 
                                 class="accordion-toggle pointer" >
                                
                                <td class="text-center fs13">
                                    <b *ngIf="objeto.intIndice1 <0"  >{{ objeto.strAlm_OrigenNombre }}</b>
                                    <span *ngIf="objeto.intIndice1 >=0" >{{ objeto.strAlm_OrigenNombre }}</span>
                                </td>
                                <td class="text-center fs12">
                                    <b *ngIf="objeto.intIndice2 <0"  >{{ objeto.strAlm_destinoNombre }}</b>
                                    <span *ngIf="objeto.intIndice2 >=0" >{{ objeto.strAlm_destinoNombre }}</span>
                                </td>
                                <td class="thright fs12">{{ objeto.dblVolumen |number:'1.2-2'}}  m<sup class="superscript">3</sup></td>
                                <td class="thright fs12">{{ objeto.dblPeso |number:'1.2-2'}}</td> 
                                <td class="text-center "> 
                                    <button type="button" class="btn btn-primary fs12 fw-bold px-2 py-1 d-flex mx-auto" (click)="fnTransito(objeto.strAlm_Origen, objeto.strAlm_destino)"><i class="bi bi-arrows-collapse"></i> <span>Unificar</span></button>

                                </td>
                            </tr>
                            <tr class="collapse details-row details-row" id="details-{{ind}}" >
                                    <td colspan="5">
                                      <div class="p-4 collapse.details-row">
                                          <!--<div class="row" *ngIf="!spinerTabla">
                                            <div class="col-12 d-flex justify-content-center">
                                                <img  src="assets/img/cargando.gif" class="text-center" alt="" >
                                            </div>
                                          </div> -->
                                          <div class="row"  >
                                              <div class="h20flow">

                                             
                                            <table class="mb-0 table table-striped table-bordered h20flow ">
                                                <thead>
                                                    <tr class=" thcenter sticky-header" style="font-size: 11px;">
                                                        <th>Artículo</th>
                                                        <th>Descripción</th> 
                                                        <th>Cantidad</th> 
                                                        <th>Unidad</th>
                                                        <th>Volumen</th>
                                                        <th>Peso</th> 
                                                        
                                                    </tr>
                                                </thead>  
                                                <tbody  *ngFor="let art of objeto.cuerpo" style="font-size: 11px;">
                                                    <tr [ngClass]="{'letra-verde': art.intPorvender > 0}">
                                                        <td> {{art.strArticulo}} -{{art.intPorvender}} </td>
                                                        <td> {{art.strDescripcion}}</td>
                                                        <td>  
                                                            
                                                        

                                                            
  <div style="position: relative;">
    <div class="input-group dropdown">
      <input type="text" class="form-control" [(ngModel)]="art.dblCantidad">
      <button class="btn btn-secondary dropdown-toggle menupasar" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
        Acción
      </button>
      <ul class="dropdown-menu menupasar1">
        <li>
          <a class="dropdown-item"
             (click)="fnSetEditar(objeto.strAlm_Origen, objeto.strAlm_destino, 'EDITAR', art.intID, art.strArticulo, art.strOpcion, art.dblCantidad)">
            Editar
          </a>
        </li>
        <li><hr class="dropdown-divider"></li>
        <li>
          <a class="dropdown-item"
             (click)="fnSetEditar(objeto.strAlm_Origen, objeto.strAlm_destino, 'ELIMINAR', art.intID, art.strArticulo, art.strOpcion, art.dblCantidad)">
            Eliminar
          </a>
        </li>
      </ul>
    </div>
  </div>




                                                
                                                            <!-- <div class="input-group ">
                                                                <input type="text" class="form-control" aria-label="Text input with dropdown button" [(ngModel)]="art.dblCantidad">
                                                                
                                                                  <button class="btn btn-outline-secondary dropdown-toggle menupasar" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Acción</button>
                                                                  <div class="dropdown-menu menupasar1"> 
                                                                    <a class="dropdown-item" (click)="fnSetEditar(objeto.strAlm_Origen, objeto.strAlm_destino,'EDITAR',art.intID, art.strArticulo, art.strOpcion,art.dblCantidad)">Editar</a>
                                                                    <div role="separator" class="dropdown-divider"></div>
                                                                    <a class="dropdown-item" (click)="fnSetEditar(objeto.strAlm_Origen, objeto.strAlm_destino,'ELIMINAR',art.intID, art.strArticulo, art.strOpcion,art.dblCantidad)">Eliminar</a>
                                                                  </div>
                                                                
                                                              </div> -->

                                                        </td>
                                                        <td>{{art.strUnidad}}</td>
                                                        <td> {{(art.dblCantidad * art.dblVolumen) |number:'1.2-2'}}</td>
                                                        <td> {{(art.dblCantidad * art.dblPeso) |number:'1.2-2'}}</td>
                                                       
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                          </div>
                                      </div>
                                    </td>
                                  </tr> 
                              
                         
                    

                        </tbody>
                        <tfoot>
                            <tr class="fijebot">
                                
                                <td  class="fw-bold tbotleftRound">  TOTALES:</td> 
                                <td  class="fw-bold text-center">  {{arrayTransitos ? arrayTransitos.length:0}}</td> 
                                <td class="thright fw-bold">{{fnsumarVolumen()| number:'1.2-2'}} m<sup class="superscript">3</sup></td>
                                <td class="thright fw-bold">{{fnsumarPeso()| number:'1.2-2'}} kg </td>
                                
                                <td class="fw-bold tbotEndRound">  </td> 
                             </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    

   <!--  <div class="row">
        <div class="col-12">
           
            <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Dropdown button
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </div>
        </div>
    </div> -->
</div>